module.exports = __webpack_public_path__ + "static/media/aboutFPGA.ff4a2018.svg";